module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori4-8bf3d850adcb9b72c718adc830430de5.jpg";